// removed by extract-text-webpack-plugin
module.exports = {"stepContent":"G1f60d1","numberOfPeopleInputContainer":"G118be5"};